import { FunctionComponent } from 'react';
import { StyledCardStatus } from './CardStatus.styled';

export const CardStatus: FunctionComponent = props => {
  const { children } = props;

  return <StyledCardStatus>{children}</StyledCardStatus>;
};
